import React from "react";
import styles from "../styles/menus-evento.module.css";

export default function MenusHeader() {
    return (
        <div className={styles.titlebar}>
            <div>
                <h2 className={styles.title}>Menús por evento</h2>
            </div>
        </div>
    );
}
